module.exports = __webpack_public_path__ + "media/images/team/AnaIsabelPereira-1287d6c5e7df384c251faf464ff3c47d.png";